import './App.css';
import WeatherApp from './components/Herosection';

function App() {
  return (
   <>
   
    <WeatherApp/>

   </>
  );
}

export default App;
